<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <h2>
      {{data.label}}
    </h2>
    <p [innerHTML]="data.text"></p>
    <qr-code-display [qrData]="qrcodesvg" [autoActivate]="true" [animate]="true"></qr-code-display>
    <div class="qrcode-text">
      <div class="inline-icon hyp-filter-svg" inlineSVG="shop-icons.svg#ya-hypersoft-coupon"></div>
      <h4>{{data.displayCode}}</h4>
    </div>
  </div>
</div>